import classNames from "classnames";

import styles from "./DateInput.module.css";

export type DateString = `${number}-${number}-${number}` | "";

type DateInputProps = {
  className?: string;
  value: DateString;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onChangeDate?: (date: DateString) => void;
  disabled?: boolean;
  colorVariant?: "grey" | "brand";
} & Omit<
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  >,
  "type"
>;

export default function DateInput({
  className,
  value,
  onChange,
  onChangeDate,
  colorVariant = "brand",
  ...rest
}: DateInputProps) {
  return (
    <input
      className={classNames(
        styles.input,
        className,
        colorVariant === "grey" && styles.grey,
      )}
      type="date"
      value={value}
      onChange={(event) => {
        onChange?.(event);
        onChangeDate?.(event.target.value as DateString);
      }}
      {...rest}
    />
  );
}
